export class PanelsUtility {

    public static setupPanel(parentSelector: any, panelId: string, panelTitle: string): JQuery<HTMLElement> {
        const imgSourceExpanded = "/App_Themes/Orion/Images/CollapseIcon.png";
        const imgSourceCollapsed = "/App_Themes/Orion/Images/ExpandIcon.png";
    
        let panelContent = '<div class="panel panel-border"><div class="panel-heading Distinguish Collapsible" role="tab" id="{panelId}Header"><h2 class="panel-title"><a role="button" data-toggle="collapse" href="#{panelId}" aria-controls="{panelId}">{panelTitle}</a></h2><div class="panel-heading-options"><a title="Click to collapse/expand." class="panel-heading-collapse" data-toggle="collapse" href="#{panelId}"><img class="panel-heading-collapse-img" src="{imgSource}" /><span class="panel-heading-collapse-text screen-reader-text">Show</span></a></div></div><div id="{panelId}" class="panel-body-container panel-collapse collapse in" role="tabpanel" aria-labelledby="{panelId}Header"><div class="panel-body"></div></div></div>';
        panelContent = panelContent.replace(/{panelId}/g, panelId);
        panelContent = panelContent.replace(/{panelTitle}/g, panelTitle);
        panelContent = panelContent.replace(/{imgSource}/g, imgSourceExpanded);
    
        let jPanel = jQuery(panelContent);
        let jPanelScreenReader = jPanel.find(".panel-heading-collapse-text");
        let jPanelCollapsibleImage = jPanel.find(".panel-heading-collapse-img");
    
        let jPanelBodyContainer = jPanel.find("#" + panelId).data({
            collapsedText: "Show",
            expandedText: "Hide",
            collapsedImage: imgSourceCollapsed,
            expandedImage: imgSourceExpanded
        });
        jPanelBodyContainer.on("shown.bs.collapse", function () {
            jPanelScreenReader.text(jPanelBodyContainer.data("expandedText"));
            jPanelCollapsibleImage.attr("src", jPanelBodyContainer.data("expandedImage"));
        });
        jPanelBodyContainer.on("hidden.bs.collapse", function () {
            jPanelScreenReader.text(jPanelBodyContainer.data("collapsedText"));
            jPanelCollapsibleImage.attr("src", jPanelBodyContainer.data("collapsedImage"));
        });
    
        jQuery(parentSelector).append(jPanel);
    
        // retun the panel body into which content will get added
        return jPanelBodyContainer.find("div");
    }
    
}